export const RUN_URL = 'https://api.hackerearth.com/v3/code/run/'
export const CLIENT_SECRET = process.env.REACT_APP_HackerearthApiKey
export const lang = 'JAVASCRIPT_NODE'
